import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withGraphQLProvider = WrappedComponent => {
  var Hoc = props => {
    var _useAllhomesApi = useAllhomesApi(),
      getApolloClient = _useAllhomesApi.getApolloClient;
    var client = getApolloClient();
    return client && ___EmotionJSX(ApolloProvider, {
      client: client
    }, ___EmotionJSX(WrappedComponent, props));
  };
  setHOCDisplayName(Hoc, WrappedComponent, 'graphqlProvider');
  return Hoc;
};
export default withGraphQLProvider;